import { trainingSessionTypes } from '../Constants'

export type SessionType = typeof trainingSessionTypes[keyof typeof trainingSessionTypes]
export const SessionTypes: SessionType[] = Object.values(trainingSessionTypes)
